const baseText = 'Offer'
const mainHeaderConfig = {
  baseText,
  selectedLabel: `${baseText}s Selected`,
  normSelectedLabel: `Norm ${baseText}s Selected`
}

export default mainHeaderConfig



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/generic/MainHeader.js